<template>
  <div id="centerRight1">
    <div class="chartInstanceBox">
      <div class="chartInstanceBoxTitle">
        薪资分布
      </div>
      <div id="chartInstance" ref="chartInstance"> </div>
    </div>
    <div class="chartInstanceBox">
      <div class="chartInstanceBoxTitle">
        劳动力分布
      </div>
      <div id="chartInstance" ref="chartInstance2"> </div>
    </div>
  </div>
</template>

<script>
import { getSalaryDistributionApi, getMemberAreaCountApi } from '@/utils/api'

export default {
  data() {
    return {
      salaryDistribution: [],
      memberAreaCount: [],
      max: 0,
      showData: '',
      sumNumber: 0,
      number_sure: 0,
      sum: 0,

      max2: 0,
      showData2: '',
      sumNumber2: 0,
      number_sure2: 0,
      sum2: 0
    }
  },
  mounted() {
    this.getSalaryDistribution()
    this.getMemberAreaCount()
  },
  methods: {

    async getSalaryDistribution(data) {
      await getSalaryDistributionApi({
        ...data,
      }).then(res => {
        this.sum = 0
        res.data.data.map((item) => {
          this.sum += item.value
          if (item.value >= this.max) this.max = item.value;
        });
        // 放大规则
        this.number_sure = Math.round(this.max * 6);
        this.salaryDistribution = res.data.data.map(item => {
          return {
            value: this.number_sure + item.value,
            name: item.name
          }
        })
        this.chartInstanceInit()
      })
    },

    async getMemberAreaCount(data) {
      await getMemberAreaCountApi({
        ...data,
      }).then(res => {
        this.sum2 = 0
        res.data.data.map((item) => {
          this.sum2 += item.value
          if (item.value >= this.max2) this.max2 = item.value;
        });
        // 放大规则
        this.number_sure2 = Math.round(this.max2 * 6);
        this.memberAreaCount = res.data.data.map(item => {
          return {
            value: this.number_sure2 + item.value,
            name: item.name
          }
        })
        // this.memberAreaCount = res.data.data
        this.chartInstanceInit2()
      })
    },

    chartInstanceInit() {
      const chartInstance = this.$echarts.init(this.$refs.chartInstance)
      const initOption = {
        tooltip: {
          trigger: 'item',
          formatter: (param) => { //还原正常值
            return param.name + ': ' + (param.value - this.number_sure)
          }
        },

        legend: {
          orient: 'vertical', //竖向展示
          right: '20',
          height: '80',  //图例容器的高度，超过会换行展示
          top: '28%',
          type:'scroll',
          icon: 'circle',  //图标样式设置
          itemWidth: 10,   //图标宽设置
          itemHeight: 10,  //图标长设置
          itemGap: 12,  //图标之间的距离
          textStyle: {
            color: '#ffffff'
          }
        },


        series: [
          {
            type: 'pie',
            radius: ['0%', '90%'],
            center: ['28%', '50%'],
            roseType: 'radius',
            itemStyle: {
              // borderRadius: 5
            },
            label: {
              show: true,
              position: "inside",
              formatter: `{d}%`,
              textStyle: {
                //图例中文字的样式
                color: "#ffffff",
                fontSize: 9,
              },
            },

            data: this.salaryDistribution
          }
        ],
        radiusScale: true
      }
      chartInstance.setOption(initOption)
    },

    chartInstanceInit2() {
      const chartInstance = this.$echarts.init(this.$refs.chartInstance2)
      const initOption = {
        tooltip: {
          trigger: 'item',
          formatter: (param) => { //还原正常值
            return param.name + ': ' + (param.value - this.number_sure2)
          }
        },

        legend: {
          orient: 'vertical', //竖向展示
          right: '20',
          height: '80',  //图例容器的高度，超过会换行展示
          top: '28%',
          type:'scroll',
          icon: 'circle',  //图标样式设置
          itemWidth: 10,   //图标宽设置
          itemHeight: 10,  //图标长设置
          itemGap: 12,  //图标之间的距离
          textStyle: {
            color: '#ffffff'
          }
        },


        series: [
          {
            type: 'pie',
            radius: ['0%', '90%'],
            center: ['50%', '50%'],
            roseType: 'radius',
            itemStyle: {
              // borderRadius: 5
            },
            label: {
              show: true,
              position: "inside",
              formatter: `{d}%`,
              textStyle: {
                //图例中文字的样式
                color: "#ffffff",
                fontSize: 9,
              },
            },

            data: this.memberAreaCount
          }
        ]
      }
      chartInstance.setOption(initOption)
    },

  }
}
</script>

<style lang="scss" scoped>
#chartInstance {
  width: 480px;
  height: 180px;
}

.chartInstanceBox {
  position: relative;
  width: 480px;
  height: 180px;

  .chartInstanceBoxTitle {
    position: absolute;
    top: 0;
    right: 21px;
    font-weight: bold;
    font-size: 28px;
    color: #0EE1F4;
    background: linear-gradient(179deg, #0EE1F4 0%, #0096FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
